import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import ConfirmDialog from "./confirm-dialog/ConfirmDialog";

interface PasswordResetByAdminConfirmDialogProps extends PropsWithChildren {
  onConfirm: () => void;
}

export function PasswordResetByAdminConfirmDialog({
  onConfirm,
  children,
}: PasswordResetByAdminConfirmDialogProps) {
  const { t } = useTranslation();

  return (
    <ConfirmDialog
      title={t("resetPasswordByAdmin.title")}
      content={
        <p className="text-sm text-muted-foreground">
          {t("resetPasswordByAdmin.description")}
        </p>
      }
      yesLabel={t("resetPasswordByAdmin.confirm")}
      noLabel={t("common.cancel")}
      onConfirm={onConfirm}
    >
      {children}
    </ConfirmDialog>
  );
}
